// eslint-disable-next-line
import * as React from 'react';
import './BpiView.css';
import { BpiCategory } from '../../entities/BpiEntities';
import { ConnectedProps, connect } from 'react-redux';
import { ApplicationState } from '../../store';
import * as BpiReducer from '../../store/BpiReducer';
import * as MessageReducer from '../../store/MessageReducer';

// ------------------------------------------------------------------------------------------------
// component

const connector = connect(
    (state: ApplicationState) => { return { bpiState: state.bpiState, messageState: state.messageState } },
    { ...BpiReducer.actionCreators, ...MessageReducer.actionCreators }
);

type PropsFromRedux = ConnectedProps<typeof connector>

type Props = PropsFromRedux & {
}

type State = {}

class BpiSummaryView extends React.Component<Props, State> {

    // --------------------------------------------------------------------------------------------
    // render

    public render() {
        return (
            <div>
                {this.props.bpiState.categories.map((category: BpiCategory) => {
                    return (
                        <div key={category.code}>
                            <h3 id={category.code}>{category.label}</h3>
                            <ul>
                                {category.children.map((subCategory: BpiCategory) => {
                                    return (
                                        <li>
                                            <a href={`/bpi/${subCategory.code}`}>{subCategory.label}</a>
                                        </li>
                                    )
                                })}
                            </ul>
                        </div>
                    )
                })}
            </div>
        )
    };
};

export default connector(BpiSummaryView);